// extracted by mini-css-extract-plugin
export default {"postPageTagContainer":"nITq6z","tagLabel":"fxkqDZ","navigation":"lokQqY"};